import { Component,  OnInit } from '@angular/core';
import { DeviceServicesInfoTableHeader } from '../../models/DeviceServicesInfoTableHeader';
import { LocalDataSource } from 'ng2-smart-table';
import { HttpServices } from '../../services/http-services';
import { AlertService } from '../../services/alert.service';
import { LoraInfoServ } from '../../interfaces/lora-infoServ'
import { InfoSelDev } from '../../interfaces/lora-IfSelDev';
import { PrintTableService } from '../../services/printTableService';

@Component({
  selector: 'devices-services',
  templateUrl: 'devices-services.component.html',
  styleUrls: ['devices-services.component.sass']
})

export class DevicesServicesComponent implements OnInit {
  dataTable: LoraInfoServ[];
  dataTablePrevState: LoraInfoServ[];
  selectedDevice: InfoSelDev = { appKey: 'не выбран', appEui: 'не выбран', creationTime: 'не выбран' };
  styleDefaultDevice: boolean = true;
  titleSelectedDevice: string = '';
  settings = DeviceServicesInfoTableHeader;
  activeCounter: number = 0;
  allCounter: number = 0;
  boxToggle: boolean = false;
  source: LocalDataSource;
  showLoader: boolean = false;

  constructor(private http: HttpServices, private printtable: PrintTableService, private alert: AlertService) { }
  ngOnInit () {
    this.getInfoServiceDevices();
  }

  getInfoServiceDevices() {
    this.boxToggle = false;
    this.showLoader = true;
    this.http.getInfoServices()
      .subscribe(
        data => {
          this.dataTable = data;
          this.dataTable.forEach(item => {
            item.creationTime = new Date(item.creationTime * 1000).toLocaleString('ru', {
              timeZone: 'UTC',
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric'
            });
            if (item.deletionTime !== null) {
              item.deletionTime = new Date(item.deletionTime * 1000).toLocaleString('ru', {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
              })
            } else this.activeCounter++;
          });
          this.allCounter = this.dataTable.length;
          this.source = new LocalDataSource(this.dataTable);
          this.alert.success('Данные по устройствам загружены');
          setTimeout(() => {
            this.showLoader = false;
          }, 300);
        },
        error => {
          console.log(error);
          this.alert.error('Загрузка данных устройств не удалась');
          setTimeout(() => {
            this.showLoader = false;
          }, 300);
        }
      );
  }

  selectDevice(e) {
    this.showLoader = true;
    this.http.getInfoServicesSelectedDevice(e.data.devAuditId)
      .subscribe(
        data => {
          this.selectedDevice = data;
          this.selectedDevice.creationTime = new Date(+this.selectedDevice.creationTime * 1000).toLocaleString('ru', {
            timeZone: 'UTC',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
          });
          this.titleSelectedDevice = e.data.eui;
          this.styleDefaultDevice = false;
          this.alert.success('Данные по устройству ' + e.data.eui + ' загружены');
          setTimeout(() => {
            this.showLoader = false;
          }, 300);
        },
        error => {
          console.log(error);
          this.alert.error('Загрузка данных по ' + e.data.eui + ' не удалась');
          setTimeout(() => {
            this.showLoader = false;
          }, 300);
        }
      );
  }

  print(): void  {
    this.printtable.print('print-section');
  }

  activeToggleDevice(e) {
    if (e) {
      this.dataTablePrevState = this.dataTable;
      this.dataTable = this.dataTable.filter(item => {
        return item.deletionTime === null;
      });
    } else {
      this.dataTable = this.dataTablePrevState;
    }
    this.source = new LocalDataSource(this.dataTable);
  }

  update() {
    this.boxToggle = false;
    this.allCounter = 0;
    this.activeCounter = 0;
    this.getInfoServiceDevices();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/devices-services/devices-services.component.ts